<template>
	<div class="contains">
		<div class="flex">
			<div class="title" @mouseenter="enter(1)" @mouseleave="leave(1)">
				总览
				<i class="el-icon-warning"></i>
				<div :class="classes">
					<p>
						<span>总咨询量</span>当日的接待量包含排队
					</p>
					<p>
						<span>转接量</span>当日转接出去的咨询数
					</p>

					<p>
						<span>接入率</span>已接入会话和总会话的比值
					</p>

					<p>
						<span>转接量</span>转出会话的数量，转出的会话不计入接入会话数中
					</p>
					<p>
						<span>总会话量</span>客服和访客发出的总消息数
					</p>
					<p>
						<span>答问比</span>客服发出消息与访客发出消息的比值
					</p>
					<p>
						<span>30s应答率</span>响应时间在30s内的占比
					</p>
					<p>
						<span>平均会话时长</span>访客进入到会话结束时间间隔的平均值
					</p>
					<p>
						<span>平均首次响应时间</span>访客首次询问和客服回复时间间隔的平均值
					</p>
					<p>
						<span>平均响应时间</span>所有访客询问和客服回复时间间隔的平均值
					</p>
					<p>
						<span>相对满意度</span>满意数量（包含非常满意和满意）和评价数量的比值
					</p>
					<p>
						<span>参评率</span>参加评价的数量和接入会话数量的比值
					</p>
					<p>
						<span>一次性解决率</span>统计周期内，访客未二次来访的会话与总会话数的比值，此数据有一定时间延迟
					</p>
					<p>
						<span>用户解决率</span>用户选择状态为“已解决”的会话量与用户选择过状态的会话数的比值
					</p>
					<p>
						<span>排队量</span>经过排队进入人工咨询的会话量
					</p>
					<p>
						<span>平均排队时长</span>开始排队到进入咨询的平均时间
					</p>
					<p>
						<span>最长排队时长</span>开始排队到进入咨询的最长时间
					</p>
					<p>
						<span>排队失败量</span>访客排队超时的人次
					</p>
					<p>
						<span>平均放弃时长</span>开始排队到放弃咨询的平均时长
					</p>
				</div>
			</div>
			<!-- <div style="float: right;width:150px;">
				<el-select v-model="value1" multiple placeholder="请选择">
					<el-option
						v-for="(item,index) in groupArr"
						:key="index"
						:label="item.groupName"
						:value="item.groupId"
					></el-option>
				</el-select>
			</div>-->
			<div style="float: right;margin-right:30px;">
				<el-button
					type="primary"
					@click="exportTable"
					:loading="exportLoading"
				>{{exportLoading?'正在处理...':'导出'}}</el-button>
			</div>
			<div style="float: right;width:150px;margin-right:20px;">
				<el-select v-model="userVal" multiple placeholder="请选择">
					<el-option
						v-for="(item,index) in userArr"
						:key="index"
						:label="item.nickName"
						:value="item.userId"
					></el-option>
				</el-select>
			</div>
			<div style="float: right;width:150px;margin-right:20px;">
				<el-select v-model="groupId" multiple placeholder="请选择">
					<el-option
						v-for="(item,index) in groupArr"
						:key="index"
						:label="item.groupName"
						:value="item.groupId"
					></el-option>
				</el-select>
			</div>
			<div class="date_box" style="float: right;;margin-right:20px;">
				<!--  -->
				<el-date-picker
					v-model="pickerTime"
					type="datetimerange"
					align="right"
					unlink-panels
					range-separator="至"
					start-placeholder="开始日期"
					end-placeholder="结束日期"
					:picker-options="pickerOptions"
					value-format="yyyy-MM-ddTHH:mm:ss"
				></el-date-picker>
			</div>
			<div class="clear"></div>
		</div>
		<div class="flex-box" style="margin-top:20px;" v-loading="userHeadLoading">
			<div class="m-ValueBox">
				<div class="m-ValueBox-top">
					<div title="接入会话量">总咨询量</div>
					<div title="0">{{userHead.sessionInfo.totalSessionCount + userHead.awaitInfo.failQueingCount}}</div>
				</div>
				<div class="m-ValueBox-bottom">
					<!-- <div title="回复率 --">
						接入率
						<span>--</span>
					</div>
					<div title="回复率 --">
						有效会话量
						<span>0</span>
					</div>-->
					<div title="回复率 --">
						转接量
						<span>{{userHead.sessionInfo.transferCount}}</span>
					</div>
				</div>
			</div>
			<div class="m-ValueBox">
				<div class="m-ValueBox-top">
					<div title="接入会话量">总会话量</div>
					<div title="0">{{userHead.totalMessage.totalMessageCount}}</div>
				</div>
				<div class="m-ValueBox-bottom">
					<div title="回复率 --">
						答问比
						<span>{{userHead.totalMessage.qrRadio}}%</span>
					</div>
					<div title="转接量 0">
						30秒应答率
						<span>{{userHead.totalMessage.s30Radio}}%</span>
					</div>
				</div>
			</div>
			<div class="m-ValueBox">
				<div class="m-ValueBox-top">
					<div title="接入会话量">平均会话时长</div>
					<div title="0">{{convertMin(userHead.avgAccessChat.aveContionSecond)}}</div>
				</div>
				<div class="m-ValueBox-bottom">
					<div title="回复率 --">
						今日首次响应时长
						<span>{{convertMin(userHead.avgAccessChat.firstAvgRespon)}}</span>
					</div>
					<div title="转接量 0">
						平均响应时长
						<span>{{convertMin(userHead.avgAccessChat.avgResponse)}}</span>
					</div>
				</div>
			</div>

			<div class="m-ValueBox">
				<div class="m-ValueBox-top">
					<div title="接入会话量">相对满意度</div>
					<div title="0">{{userHead.commentInfo.praiseRate}}%</div>
				</div>
				<div class="m-ValueBox-bottom">
					<div title="回复率">
						参评率
						<span>{{userHead.commentInfo.participationRate}}%</span>
					</div>
					<div title="回复率">
						一次性解决率
						<span>{{userHead.commentInfo.onceRate}}%</span>
					</div>
					<!-- <div title="回复率">
						用户解决率
						<span>0.00%</span>
					</div>-->
				</div>
			</div>
			<div class="m-ValueBox">
				<div class="m-ValueBox-top">
					<div title="接入会话量">排队量</div>
					<div title="0">{{userHead.awaitInfo.awaitCount}}</div>
				</div>
				<div class="m-ValueBox-bottom">
					<div title="回复率">平均排队时长:{{convertMin(userHead.awaitInfo.avgQueuingTime)}}</div>
					<div title="回复率">最长排队时长:{{convertMin(userHead.awaitInfo.longestQueuingTime)}}</div>
				</div>
			</div>
			<div class="m-ValueBox">
				<div class="m-ValueBox-top">
					<div title="接入会话量">排队失败量</div>
					<div title="0">{{userHead.awaitInfo.failQueingCount}}</div>
				</div>
				<div class="m-ValueBox-bottom">
					<div title="回复率">平均放弃时长:{{convertMin(userHead.awaitInfo.avgLeaveTime)}}</div>
					<div>接入率:{{userHead.awaitInfo.accessRate}}</div>
					<div>放弃率:{{userHead.awaitInfo.failQueingRate}}</div>
				</div>
			</div>
		</div>
		<div class="m-echart">
			<div class="m-echart-title">
				<div>
					<span class="m-echart-titleTxt" @mouseenter="enter(2)" @mouseleave="leave(2)">
						会话量
						<i class="el-icon-warning"></i>
						<div :class="classes2">
							<p>
								<span>接待量</span> 当前接待(次)量
							</p>
							<p>
								<span>排队量</span> 所选时间范围内，发生排队的总次数
							</p>
							<p>
								<span>接入率</span> 接待量 / 咨询量（接待量 + 排队失败）
							</p>
						</div>
					</span>
				</div>
			</div>
			<div id="main-1" style="width:100%;height:420px;" v-loading="accountReportLoading"></div>
		</div>
		<div class="m-echart">
			<div class="m-echart-title">
				<div>
					<span class="m-echart-titleTxt" @mouseenter="enter(3)" @mouseleave="leave(3)">
						消息量
						<i class="el-icon-warning"></i>
						<div :class="classes3">
							<p>此图表可根据时间趋势比较消息量变化情况，其中包含客服发出消息和访客发出消息</p>
						</div>
					</span>
				</div>
			</div>
			<div id="main-2" style="width:100%;height:420px;" v-loading="messageTrendChartLoading"></div>
		</div>
		<div class="m-echart">
			<div class="m-echart-title">
				<div>
					<span class="m-echart-titleTxt" @mouseenter="enter(3)" @mouseleave="leave(3)">
						响应时长
						<!-- <i class="el-icon-warning"></i> -->
						<!-- <div :class="classes3">
							<p>此图表可根据时间趋势比较消息量变化情况，其中包含客服发出消息和访客发出消息</p>
						</div>-->
					</span>
				</div>
			</div>
			<div id="main-7" style="width:100%;height:420px;" v-loading="messageTrendChartLoading"></div>
		</div>
		<div class="m-echart">
			<div class="m-echart-title">
				<div>
					<span class="m-echart-titleTxt" @mouseenter="enter(3)" @mouseleave="leave(3)">
						平均在线人数
						<i class="el-icon-warning"></i>
						<div :class="classes3">
							<p>就绪总时长/9h</p>
						</div>
					</span>
				</div>
			</div>
			<div id="onLineCount" style="width:100%;height:420px;" v-loading="messageTrendChartLoading"></div>
		</div>
		<div class="flex-box" style="min-height:270px;" v-loading="historyResponseLoading">
			<div class="m-echart">
				<div class="m-echart-title">
					<div>
						<span class="m-echart-titleTxt" @mouseenter="enter(4)" @mouseleave="leave(4)">
							首次响应时间
							<i class="el-icon-warning"></i>
							<div :class="classes4">
								<p>一次会话中，访客首条消息与客服首次回应的时间间隔</p>
							</div>
						</span>
					</div>
				</div>
				<div class="main-3" style="height:300px;">
					<div class="m-bar">
						<div class="m-bar-title">>1m</div>
						<div class="progress">
							<div class="p1" :style="{width:response.firstResponse.firstResponseGreaterThan1m+ '%'}"></div>
						</div>
						<div class="percent">{{response.firstResponse.firstResponseGreaterThan1m}}%</div>
					</div>
					<div class="m-bar">
						<div class="m-bar-title">45s-1m</div>
						<div class="progress">
							<div class="p2" :style="{width:response.firstResponse.firstResponse45sAnd1m+ '%'}"></div>
						</div>
						<div class="percent">{{response.firstResponse.firstResponse45sAnd1m}}%</div>
					</div>
					<div class="m-bar">
						<div class="m-bar-title">30s-45s</div>
						<div class="progress">
							<div class="p3" :style="{width:response.firstResponse.firstResponse30sAnd45s+ '%'}"></div>
						</div>
						<div class="percent">{{response.firstResponse.firstResponse30sAnd45s}}%</div>
					</div>
					<div class="m-bar">
						<div class="m-bar-title">15s-30s</div>
						<div class="progress">
							<div class="p4" :style="{width:response.firstResponse.firstResponse15sAnd30s+ '%'}"></div>
						</div>
						<div class="percent">{{response.firstResponse.firstResponse15sAnd30s}}%</div>
					</div>
					<div class="m-bar">
						<div class="m-bar-title">15s</div>
						<div class="progress">
							<div class="p5" :style="{width:response.firstResponse.firstResponse15s+ '%'}"></div>
						</div>
						<div class="percent">{{response.firstResponse.firstResponse15s}}%</div>
					</div>
				</div>
			</div>
			<div class="m-echart">
				<div class="m-echart-title">
					<div>
						<span class="m-echart-titleTxt" @mouseenter="enter(5)" @mouseleave="leave(5)">
							响应时间
							<i class="el-icon-warning"></i>
							<div :class="classes5">
								<p>访客的每次询问与客服回应的时间间隔，连续多条消息在统计中将被合并</p>
							</div>
						</span>
					</div>
				</div>
				<div class="main-4" style="height:300px;">
					<div class="m-bar">
						<div class="m-bar-title">>1m</div>
						<div class="progress">
							<div class="p1" :style="{width:response.userResponse.responseGreaterThan1m+ '%'}"></div>
						</div>
						<div class="percent">{{response.userResponse.responseGreaterThan1m}}%</div>
					</div>
					<div class="m-bar">
						<div class="m-bar-title">45s-1m</div>
						<div class="progress">
							<div class="p2" :style="{width:response.userResponse.response45sAnd1m+ '%'}"></div>
						</div>
						<div class="percent">{{response.userResponse.response45sAnd1m}}%</div>
					</div>
					<div class="m-bar">
						<div class="m-bar-title">30s-45s</div>
						<div class="progress">
							<div class="p3" :style="{width:response.userResponse.response30sAnd45s+ '%'}"></div>
						</div>
						<div class="percent">{{response.userResponse.response30sAnd45s}}%</div>
					</div>
					<div class="m-bar">
						<div class="m-bar-title">15s-30s</div>
						<div class="progress">
							<div class="p4" :style="{width:response.userResponse.response15sAnd30s+ '%'}"></div>
						</div>
						<div class="percent">{{response.userResponse.response15sAnd30s}}%</div>
					</div>
					<div class="m-bar">
						<div class="m-bar-title">15s</div>
						<div class="progress">
							<div class="p5" :style="{width:response.userResponse.response15s+ '%'}"></div>
						</div>
						<div class="percent">{{response.userResponse.response15s}}%</div>
					</div>
				</div>
			</div>
			<div class="m-echart">
				<div class="m-echart-title">
					<div>
						<span class="m-echart-titleTxt" @mouseenter="enter(6)" @mouseleave="leave(6)">
							会话时长
							<i class="el-icon-warning"></i>
							<div :class="classes6">
								<p>从访客发起会话到会话关闭的时间间隔</p>
							</div>
						</span>
					</div>
				</div>
				<div class="main-5" style="height:300px;">
					<div class="m-bar">
						<div class="m-bar-title">>8m</div>
						<div class="progress">
							<div class="p1" :style="{width:response.duration.durationGreaterThan8m+ '%'}"></div>
						</div>
						<div class="percent">{{response.duration.durationGreaterThan8m}}%</div>
					</div>
					<div class="m-bar">
						<div class="m-bar-title">6m-8m</div>
						<div class="progress">
							<div class="p2" :style="{width:response.duration.duration6mAnd8m+ '%'}"></div>
						</div>
						<div class="percent">{{response.duration.duration6mAnd8m}}%</div>
					</div>
					<div class="m-bar">
						<div class="m-bar-title">4m-6m</div>
						<div class="progress">
							<div class="p3" :style="{width:response.duration.duration4mAnd6m+ '%'}"></div>
						</div>
						<div class="percent">{{response.duration.duration4mAnd6m}}%</div>
					</div>
					<div class="m-bar">
						<div class="m-bar-title">2m-4m</div>
						<div class="progress">
							<div class="p4" :style="{width:response.duration.duration2mAnd4m+ '%'}"></div>
						</div>
						<div class="percent">{{response.duration.duration2mAnd4m}}%</div>
					</div>
					<div class="m-bar">
						<div class="m-bar-title"><2m</div>
						<div class="progress">
							<div class="p5" :style="{width:response.duration.duration2m+ '%'}"></div>
						</div>
						<div class="percent">{{response.duration.duration2m}}%</div>
					</div>
				</div>
			</div>
		</div>
		<div class="flex-box" style="min-height:370px;">
			<div class="m-echart">
				<div class="m-echart-title">
					<div>
						<span class="m-echart-titleTxt" @mouseenter="enter(7)" @mouseleave="leave(7)">
							客户来源
							<i class="el-icon-warning"></i>
							<div :class="classes7">
								<p>当日每个渠道的接入数和占比</p>
							</div>
						</span>
					</div>
				</div>
				<div id="main-3" class="canvas" style="height:300px;"></div>
			</div>
		</div>
		<div class="flex-box" style="min-height:370px;">
			<div class="m-echart">
				<div class="m-echart-title">
					<div>
						<span class="m-echart-titleTxt">问题解决率</span>
					</div>
				</div>
				<div id="main-4" class="canvas" style="height:300px;"></div>
			</div>
		</div>
		<div class="flex-box" style="min-height:370px;margin-bottom:50px">
			<div class="m-echart">
				<div class="m-echart">
					<div class="m-echart-title">
						<div>
							<span class="m-echart-titleTxt">满意度</span>
						</div>
					</div>
					<div id="main-5" class="canvas" style="height:300px;">
						<div>暂无数据</div>
					</div>
				</div>
			</div>
		</div>
		<div class="flex-box" style="min-height:370px;margin-bottom:50px">
			<div class="m-echart">
				<div class="m-echart">
					<div class="m-echart-title">
						<div>
							<span class="m-echart-titleTxt">评分</span>
						</div>
					</div>
					<div id="main-8" class="canvas" style="height:300px;">
						<div>暂无数据</div>
					</div>
				</div>
			</div>
		</div>
		<div class="flex-box" style="min-height:370px;margin-bottom:50px">
			<div class="m-echart">
				<div class="m-echart-title">
					<div>
						<span class="m-echart-titleTxt" @mouseenter="enter(8)" @mouseleave="leave(8)">
							联络原因
							<i class="el-icon-warning"></i>
							<div :class="classes8">
								<p>展示各级咨询分类的占比和各分类项数量环比增长情况</p>
							</div>
						</span>
					</div>
				</div>
				<div id="main-6" class="canvas" style="height:300px;" v-loading="consultationLoading"></div>
			</div>
		</div>
	</div>
</template>

<script>
import { DateTime } from '@/utils/common'
import { formatDuring } from '@/utils/FormatTime'
export default {
	name: 'overview',
	props: [],
	data() {
		return {
			value: '',
			value1: '',
			value2: '',
			groupId: [],
			channelId: [],
			userVal: [],
			groupArr: [
				{
					value: '选项1',
					label: '所有客服组',
				},
				{
					value: '选项2',
					label: '所有客服组',
				},
			],
			userArr: [
				{
					value: '选项1',
					label: '所有客服组',
				},
				{
					value: '选项2',
					label: '所有客服组',
				},
			],
			option3: [
				{
					value: '选项1',
					label: '所有客服组',
				},
				{
					value: '选项2',
					label: '所有客服组',
				},
			],
			tableData: [
				{
					id: 0,
					enter_time: '15:30:12',
					start_time: '15:30:12',
					end_time: '15:30:12',
					customer: '001',
					ename: '王小虎',
					sort: '无效会话',
					follow: '客服1',
					channel: '雀巢',
					session: '客服',
				},
				{
					id: 0,
					enter_time: '15:30:12',
					start_time: '15:30:12',
					end_time: '15:30:12',
					customer: '001',
					ename: '王小虎',
					sort: '无效会话',
					follow: '客服1',
					channel: '雀巢',
					session: '客服',
				},

				{
					id: 0,
					enter_time: '15:30:12',
					start_time: '15:30:12',
					end_time: '15:30:12',
					customer: '001',
					ename: '王小虎',
					sort: '无效会话',
					follow: '客服1',
					channel: '雀巢',
					session: '客服',
				},
			],
			classes: 'flex-dialog',
			classes2: 'flex-dialog',
			classes3: 'flex-dialog',
			classes4: 'flex-dialog',
			classes5: 'flex-dialog',
			classes6: 'flex-dialog',
			classes7: 'flex-dialog',
			classes8: 'flex-dialog',
			pickerTime: [],
			pickerOptions: {
				disabledDate(date) {
					return date.getTime() >= Date.now()
				},
				shortcuts: [
					{
						text: '最近一周',
						onClick(picker) {
							const end = new Date()
							const start = new Date()
							start.setTime(
								start.getTime() - 3600 * 1000 * 24 * 7
							)
							picker.$emit('pick', [start, end])
						},
					},
					{
						text: '最近一个月',
						onClick(picker) {
							const end = new Date()
							const start = new Date()
							start.setTime(
								start.getTime() - 3600 * 1000 * 24 * 30
							)
							picker.$emit('pick', [start, end])
						},
					},
					{
						text: '最近三个月',
						onClick(picker) {
							const end = new Date()
							const start = new Date()
							start.setTime(
								start.getTime() - 3600 * 1000 * 24 * 90
							)
							picker.$emit('pick', [start, end])
						},
					},
				],
			},
			userHead: {
				sessionInfo: {
					totalSessionCount: 0,
					transferCount: 0,
				},
				totalMessage: {
					totalMessageCount: 0,
					qrRadio: 0,
					s30Radio: 0,
				},
				avgAccessChat: {
					aveContionSecond: 0,
					firstAvgRespon: 0,
					avgResponse: 0,
				},
				commentInfo: {
					onceRate: 0,
					participationRate: 0,
					praiseRate: 0,
				},
				awaitInfo: {
					awaitCount: 0,
					avgQueuingTime: 0,
					longestQueuingTime: 0,
					failQueingCount: 0,
					avgLeaveTime: 0,
				},
			},
			accountCount: {},
			messageCount: {},
			response: {
				userResponse: {
					response15s: 0,
					response15sAnd30s: 0,
					response30sAnd45s: 0,
					response45sAnd1m: 0,
					responseGreaterThan1m: 0,
				},
				firstResponse: {
					firstResponse15s: 0,
					firstResponse15sAnd30s: 0,
					firstResponse30sAnd45s: 0,
					firstResponse45sAnd1m: 0,
					firstResponseGreaterThan1m: 0,
				},
				duration: {
					duration2m: 0,
					duration2mAnd4m: 0,
					duration4mAnd6m: 0,
					duration6mAnd8m: 0,
					durationGreaterThan8m: 0,
				},
			},
			userHeadLoading: false,
			accountReportLoading: false,
			messageTrendChartLoading: false,
			historyResponseLoading: false,
			consultationLoading: false,
			exportLoading: false,
		}
	},
	watch: {
		groupId: function (val) {
			let vm = this
			vm.channelId = []
			if (val.length > 0) {
				val.forEach((item) => {
					let obj = vm.groupArr.find((d) => d.groupId == item)
					if (obj != undefined) {
						vm.channelId = vm.channelId.concat(obj.channelList)
					}
				})
			}
			this.dynamic()
			this.getUser(val)
			if (val.length == 0) {
				this.userVal = []
			}
		},
		pickerTime: function (val) {
			this.dynamic()
		},
		userVal: function (val) {
			if (val.length > 0) {
				this.dynamic()
			}
		},
	},
	mounted: function () {
		let datetime = new DateTime()
		this.pickerTime.push(datetime.getYesterday() + 'T00:00:00')
		this.pickerTime.push(datetime.getYesterday() + 'T23:59:59')
		this.getGroup()
		this.getUser()
		this.dynamic()
		this.getChannelGroup()
	},
	methods: {
		dynamic() {
			//
			this.getHead()
			this.getCenterAccountReport()
			this.getMessageTrendChart()
			this.getHistoryResponse() //获取响应时长
			this.getChannelGroup()
			this.getProbleSolvingRate()
			this.getGetConsultationGroups()
			this.getAvgResponse() //获取平均响应时长
			this.getOnlineUserCount()
		},
		getGroup() {
			//获取分组
			let vm = this
			this.axios
				.get('RealTimeStatistics/GetGroup')
				.then(function ({ data }) {
					if (data.result) {
						vm.groupArr = data.data
					}
				})
		},
		getUser() {
			let vm = this
			this.axios
				.get('RealTimeStatistics/GetUser')
				.then(function ({ data }) {
					if (data.result) {
						vm.userArr = data.data
					}
				})
		},
		// getHead() {
		// 	let vm = this
		// 	this.axios
		// 		.post('HistoryReportForm/GetHead', vm.getWhere())
		// 		.then(function({ data }) {
		// 			if (data.result) {
		// 				console.log(data)
		// 			}
		// 		})
		// },
		getWhere() {
			let vm = this
			let obj = {}
			obj.groupId = []
			obj.userId = new Set(vm.userVal)
			obj.channelId = new Set(vm.channelId)
			if (vm.pickerTime.length > 0) {
				obj.startTime = vm.pickerTime[0]
				obj.endtime = vm.pickerTime[1]
			}
			return obj
		},
		getHead() {
			let vm = this
			vm.userHeadLoading = true
			this.axios
				.post('HistoryReportForm/GetHead', this.getWhere())
				.then(function ({ data }) {
					if (data.result) {
						vm.userHead = data.data
					}
					vm.userHeadLoading = false
				})
		},
		getCenterAccountReport() {
			let vm = this
			let myChart1 = this.$echarts.init(document.getElementById('main-1'))
			vm.accountReportLoading = true
			this.axios
				.post(
					'HistoryReportForm/GetCenterAccountReport',
					this.getWhere()
				)
				.then(function ({ data }) {
					console.debug(data.data)

					let option1 = {
						tooltip: {
							trigger: 'axis',
						},
						legend: {
							data: [
								data.data.connectedSession.name,
								data.data.await.name,
								data.data.accessRate.name,
							],
							x: 'center', //可设定图例在左、右、居中
							y: 'bottom',
						},
						toolbox: {
							show: false,
							feature: {
								mark: { show: true },
								dataView: { show: true, readOnly: false },
								magicType: {
									show: true,
									type: ['line', 'bar', 'stack', 'tiled'],
								},
								restore: { show: true },
								saveAsImage: { show: true },
							},
						},
						calculable: true,
						xAxis: [
							{
								type: 'category',
								boundaryGap: false,
								data: data.data.accessRate.list.map(
									(d) => d.time
								),
							},
						],
						yAxis: [
							{
								type: 'value',
							},
						],
						series: [
							{
								name: data.data.connectedSession.name,
								type: 'line',
								stack: '3',
								data: data.data.connectedSession.list.map(
									(d) => d.count
								),
							},
							{
								name: data.data.await.name,
								type: 'line',
								stack: '4',
								data: data.data.await.list.map((d) => d.count),
							},
							{
								name: data.data.accessRate.name,
								type: 'line',
								stack: '5',
								data: data.data.accessRate.list.map((d) =>
									d.accessRate.toFixed(2)
								),
							},
						],
					}
					myChart1.setOption(option1)

					vm.accountReportLoading = false
				})
		},
		getMessageTrendChart() {
			let vm = this
			let myChart2 = this.$echarts.init(document.getElementById('main-2'))
			vm.messageTrendChartLoading = true
			this.axios
				.post('HistoryReportForm/GetMessageTrendChart', this.getWhere())
				.then(function ({ data }) {
					if (!data.result) {
						return
					}

					let option2 = {
						tooltip: {
							trigger: 'axis',
						},
						legend: {
							data: [
								data.data.customerService.name,
								data.data.visitor.name,
								data.data.connectedSession.name,
							],
							x: 'center', //可设定图例在左、右、居中
							y: 'bottom',
						},
						toolbox: {
							show: false,
							feature: {
								mark: { show: true },
								dataView: { show: true, readOnly: false },
								magicType: {
									show: true,
									type: ['line', 'bar', 'stack', 'tiled'],
								},
								restore: { show: true },
								saveAsImage: { show: true },
							},
						},
						calculable: true,
						xAxis: [
							{
								type: 'category',
								boundaryGap: false,
								data: data.data.connectedSession.list.map(
									(d) => d.time
								),
							},
						],
						yAxis: [
							{
								type: 'value',
							},
						],
						series: [
							{
								name: data.data.customerService.name,
								type: 'line',
								stack: '1',
								data: data.data.customerService.list.map(
									(d) => d.count
								),
							},
							{
								name: data.data.visitor.name,
								type: 'line',
								stack: '2',
								data: data.data.visitor.list.map(
									(d) => d.count
								),
							},
							{
								name: data.data.connectedSession.name,
								type: 'line',
								stack: '3',
								data: data.data.connectedSession.list.map(
									(d) => d.count
								),
							},
						],
					}
					myChart2.setOption(option2)
					vm.messageTrendChartLoading = false
				})
		},
		getHistoryResponse() {
			let vm = this
			vm.historyResponseLoading = true
			this.axios
				.post('HistoryReportForm/GetHistoryResponse', this.getWhere())
				.then(function ({ data }) {
					if (data.result) {
						vm.response = data.data
					}
					vm.historyResponseLoading = false
				})
		},
		getChannelGroup() {
			let vm = this
			let myChart3 = this.$echarts.init(document.getElementById('main-3'))
			this.axios
				.post(
					'HistoryReportForm/GetHistoryChannelGroups',
					this.getWhere()
				)
				.then(function ({ data }) {
					if (data.result) {
						console.debug(data)

						let arr = []
						data.data.forEach((element) => {
							var obj = new Object()
							obj.value = element.count
							obj.name = element.channelName
							obj.channelId = element.channelId
							arr.push(obj)
						})
						let option3 = {
							title: {
								left: 'center',
								top: 10 + 'px',
								text: '',
								textStyle: {
									color: '#000',
									fontSize: 16,
									fontweight: 500,
								},
							},
							legend: {
								show: true,
								icon: 'circle',
								orient: 'vertical',
								align: 'left',
								itemWidth: 12, // 设置宽度
								itemHeight: 12, // 设置高度
								x: 'right',
								y: 40 + 'px',
								data: data.data.map((d) => d.channelName),
								fontSize: 12,
							},
							label: {
								show: true,
								formatter: '{b} : {c} ({d}%)',
							},
							tooltip: {
								trigger: 'item',
								formatter: '{b} : {c} ({d}%)',
							},
							series: [
								{
									type: 'pie',
									center: ['50%', '50%'],
									radius: ['30%', '50%'],
									data: arr,
									color: [
										'rgb(230,63,67)',
										'rgb(255,143,88)',
										'rgb(255,195,55)',
										'rgb(196,153,111)',
										'#bcd3bb',
										'#e88f70',
										'#edc1a5',
										'#9dc5c8',
										'#e1e8c8',
										'#7b7c68',
										'#e5b5b5',
										'#f0b489',
									],
								},
							],
							itemStyle: {
								emphasis: {
									shadowBlur: 10,
									shadowOffsetX: 0,
									shadowColor: 'rgba(0, 0, 0, 0.5)',
								},
								// 这里做改变
								normal: {
									label: {
										show: true,
										formatter: '{b} : {c} ({d}%)',
									},
									labelLine: {
										show: true,
									},
								},
							},
						}
						// let option3 = {
						// 	title: {
						// 		left: 'center',
						// 		top: 10 + 'px',
						// 		text: '',
						// 		textStyle: {
						// 			color: '#000',
						// 			fontSize: 16,
						// 			fontweight: 500
						// 		}
						// 	},
						// 	label: {
						// 		show: true,
						// 		formatter: '{b} ({d}%)'
						// 	},
						// 	tooltip: {
						// 		trigger: 'item',
						// 		formatter: '{b} : {c} ({d}%)'
						// 	},
						// 	label: {
						// 		show: true,
						// 		formatter: '{b} ({d}%)'
						// 	},
						// 	tooltip: {
						// 		trigger: 'item',
						// 		formatter: '{b} : {c} ({d}%)'
						// 	},
						// 	legend: {
						// 		show: true,
						// 		icon: 'circle',
						// 		orient: 'vertical',
						// 		align: 'left',
						// 		itemWidth: 12, // 设置宽度
						// 		itemHeight: 12, // 设置高度
						// 		x: 'right',
						// 		y: 40 + 'px',
						// 		data: data.data.map(d => d.channelName),
						// 		fontSize: 12
						// 	},
						// 	series: [
						// 		{
						// 			label: {
						// 				normal: {
						// 					show: false,
						// 					position: 'center'
						// 				},
						// 				emphasis: {
						// 					show: true,
						// 					textStyle: {
						// 						fontSize: '12',
						// 						fontWeight: 'bold'
						// 					}
						// 				}
						// 			},
						// 			type: 'pie',
						// 			center: ['30%', '50%'],
						// 			radius: ['30%', '55%'],
						// 			data: arr,
						// 			color: [
						// 				'rgb(230,63,67)',
						// 				'rgb(255,143,88)',
						// 				'rgb(255,195,55)',
						// 				'rgb(196,153,111)',
						// 				'#bcd3bb',
						// 				'#e88f70',
						// 				'#edc1a5',
						// 				'#9dc5c8',
						// 				'#e1e8c8',
						// 				'#7b7c68',
						// 				'#e5b5b5',
						// 				'#f0b489'
						// 			]
						// 		}
						// 	],
						// 	itemStyle: {
						// 		emphasis: {
						// 			shadowBlur: 10,
						// 			shadowOffsetX: 0,
						// 			shadowColor: 'rgba(0, 0, 0, 0.5)'
						// 		},
						// 		// 这里做改变
						// 		normal: {
						// 			label: {
						// 				show: true,
						// 				formatter: '{b} : {c} ({d}%)'
						// 			},
						// 			labelLine: {
						// 				show: true
						// 			}
						// 		}
						// 	}
						// }
						myChart3.setOption(option3)
						myChart3.on('click', vm.myChart3Click)
					}
				})
		},
		myChart3Click(e) {
			let vm = this
			var { data } = e
			let channelId = data.channelId
			let startTime = vm.pickerTime[0]
			let endTime = vm.pickerTime[1]
			let obj = {
				channelId: channelId,
				startTime: startTime,
				endTime: endTime,
				type: 'channel',
				index: '3',
			}
			this.$emit('children', obj)
		},
		getProbleSolvingRate() {
			let vm = this
			let myChart4 = this.$echarts.init(document.getElementById('main-4'))
			let myChart5 = this.$echarts.init(document.getElementById('main-5'))
			let myChart8 = this.$echarts.init(document.getElementById('main-8'))
			this.axios
				.post('HistoryReportForm/GetHistoryProble', this.getWhere())
				.then(function ({ data }) {
					if (data.result) {
						// let myChart2 = this.$echarts.init(document.getElementById('main-2'))

						let commentName = data.data.degree.map(
							(d) => d.commentName
						)
						let commentArr = []

						data.data.degree.forEach((element) => {
							var obj = new Object()
							obj.value = element.count
							obj.name = element.commentName
							obj.commentId = element.commentId
							commentArr.push(obj)
						})
						var {
							unmark,
							unsolved,
							resolved,
						} = data.data.solvingRate
						debugger
						let scoreData = [];

						  data.data.scoreDegree.forEach(element=>{
							var obj = new Object()
							obj.value = element.count
							obj.name = element.score
					 
							scoreData.push(obj)
						});
						let option4 = {
							title: {
								left: 'center',
								top: 10 + 'px',
								text: '',
								textStyle: {
									color: '#000',
									fontSize: 16,
									fontweight: 500,
								},
							},
							legend: {
								show: true,
								icon: 'circle',
								orient: 'vertical',
								align: 'left',
								itemWidth: 12, // 设置宽度
								itemHeight: 12, // 设置高度
								x: 'right',
								y: 40 + 'px',
								data: [
									`未标记`,
									'未解决',
									'已解决',
									'无效会话',
								],
								fontSize: 12,
							},
							label: {
								show: true,
								formatter: '{b} : {c} ({d}%)',
							},
							tooltip: {
								trigger: 'item',
								formatter: '{b} : {c} ({d}%)',
							},
							series: [
								{
									type: 'pie',
									center: ['50%', '50%'],
									radius: ['30%', '50%'],
									data: [
										{
											value: data.data.solvingRate.unmark,
											name: '未标记',
											id: -1,
										},
										{
											value:
												data.data.solvingRate.unsolved,
											name: '未解决',
											id: 0,
										},
										{
											value:
												data.data.solvingRate.resolved,
											name: '已解决',
											id: 1,
										},
										{
											value:
												data.data.solvingRate
													.invalidSession,
											name: '无效会话',
											id: 2,
										},
									],
									color: [
										'rgb(230,63,67)',
										'rgb(255,143,88)',
										'rgb(255,195,55)',
										'rgb(196,153,111)',
										'#bcd3bb',
										'#e88f70',
										'#edc1a5',
										'#9dc5c8',
										'#e1e8c8',
										'#7b7c68',
										'#e5b5b5',
										'#f0b489',
									],
								},
							],
							itemStyle: {
								emphasis: {
									shadowBlur: 10,
									shadowOffsetX: 0,
									shadowColor: 'rgba(0, 0, 0, 0.5)',
								},
								// 这里做改变
								normal: {
									label: {
										show: true,
										formatter: '{b} : {c} ({d}%)',
									},
									labelLine: {
										show: true,
									},
								},
							},
						}
						let option5 = {
							title: {
								left: 'center',
								top: 10 + 'px',
								text: '',
								textStyle: {
									color: '#000',
									fontSize: 16,
									fontweight: 500,
								},
							},
							legend: {
								show: true,
								icon: 'circle',
								orient: 'vertical',
								align: 'left',
								itemWidth: 12, // 设置宽度
								itemHeight: 12, // 设置高度
								x: 'right',
								y: 40 + 'px',
								data: commentName,
								fontSize: 12,
							},
							label: {
								show: true,
								formatter: '{b} : {c} ({d}%)',
							},
							tooltip: {
								trigger: 'item',
								formatter: '{b} : {c} ({d}%)',
							},
							series: [
								{
									type: 'pie',
									center: ['50%', '50%'],
									radius: ['30%', '50%'],
									data: commentArr,
									color: [
										'rgb(230,63,67)',
										'rgb(255,143,88)',
										'rgb(255,195,55)',
										'rgb(196,153,111)',
										'#bcd3bb',
										'#e88f70',
										'#edc1a5',
										'#9dc5c8',
										'#e1e8c8',
										'#7b7c68',
										'#e5b5b5',
										'#f0b489',
									],
								},
							],
							itemStyle: {
								emphasis: {
									shadowBlur: 10,
									shadowOffsetX: 0,
									shadowColor: 'rgba(0, 0, 0, 0.5)',
								},
								// 这里做改变
								normal: {
									label: {
										show: true,
										formatter: '{b} : {c} ({d}%)',
									},
									labelLine: {
										show: true,
									},
								},
							},
						}

						let option7 = {
							title: {
								left: 'center',
								top: 10 + 'px',
								text: '',
								textStyle: {
									color: '#000',
									fontSize: 16,
									fontweight: 500,
								},
							},
							legend: {
								show: true,
								icon: 'circle',
								orient: 'vertical',
								align: 'left',
								itemWidth: 12, // 设置宽度
								itemHeight: 12, // 设置高度
								x: 'right',
								y: 40 + 'px',
								data: commentName,
								fontSize: 12,
							},
							label: {
								show: true,
								formatter: '{b} : {c} ({d}%)',
							},
							tooltip: {
								trigger: 'item',
								formatter: '{b} : {c} ({d}%)',
							},
							series: [
								{
									type: 'pie',
									center: ['50%', '50%'],
									radius: ['30%', '50%'],
									data: scoreData,
									color: [
										'rgb(230,63,67)',
										'rgb(255,143,88)',
										'rgb(255,195,55)',
										'rgb(196,153,111)',
										'#bcd3bb',
										'#e88f70',
										'#edc1a5',
										'#9dc5c8',
										'#e1e8c8',
										'#7b7c68',
										'#e5b5b5',
										'#f0b489',
									],
								},
							],
							itemStyle: {
								emphasis: {
									shadowBlur: 10,
									shadowOffsetX: 0,
									shadowColor: 'rgba(0, 0, 0, 0.5)',
								},
								// 这里做改变
								normal: {
									label: {
										show: true,
										formatter: '{b} : {c} ({d}%)',
									},
									labelLine: {
										show: true,
									},
								},
							},
						}
						myChart4.setOption(option4)
						myChart4.on('click', (e) => {
							let { data } = e
							let state = data.id
							let startTime = vm.pickerTime[0]
							let endTime = vm.pickerTime[1]
							let obj = {
								state: state,
								startTime: startTime,
								endTime: endTime,
								type: 'state',
								index: '3',
							}
							vm.$emit('children', obj)
						})
						myChart5.setOption(option5)
						myChart5.on('click', (e) => {
							let { data } = e
							let commentId = data.commentId
							let startTime = vm.pickerTime[0]
							let endTime = vm.pickerTime[1]
							let obj = {
								commentId: commentId,
								startTime: startTime,
								endTime: endTime,
								type: 'comment',
								index: '3',
							}
							vm.$emit('children', obj)
						})
						myChart8.setOption(option7)
							myChart8.on('click', (e) => {
							// let { data } = e
							// let commentId = data.commentId
							// let startTime = vm.pickerTime[0]
							// let endTime = vm.pickerTime[1]
							// let obj = {
							// 	commentId: commentId,
							// 	startTime: startTime,
							// 	endTime: endTime,
							// 	type: 'comment',
							// 	index: '3',
							// }
							// vm.$emit('children', obj)
						})
					}
				})
		},
		/**
		 *
		 * 获取平均响应时长
		 */
		getAvgResponse() {
			let vm = this
			let myChart7 = this.$echarts.init(document.getElementById('main-7'))
			this.axios
				.post('HistoryReportForm/GetAvgResponse', this.getWhere())
				.then(function ({ data }) {
					if (!data.result) {
						return
					}
					let option2 = {
						tooltip: {
							trigger: 'axis',
						},
						legend: {
							data: [
								'平均首次响应时长(秒)',
								'平均响应时长(秒)',
								'平均会话时长(分)',
							],
							x: 'center', //可设定图例在左、右、居中
							y: 'bottom',
						},
						toolbox: {
							show: false,
							feature: {
								mark: { show: true },
								dataView: { show: true, readOnly: false },
								magicType: {
									show: true,
									type: ['line', 'bar', 'stack', 'tiled'],
								},
								restore: { show: true },
								saveAsImage: { show: true },
							},
						},
						calculable: true,
						xAxis: [
							{
								type: 'category',
								boundaryGap: false,
								data: data.data.firstResponses.map(
									(d) => d.time
								),
							},
						],
						yAxis: [
							{
								type: 'value',
							},
						],
						series: [
							{
								name: '平均首次响应时长(秒)',
								type: 'line',
								stack: '1',
								data: data.data.firstResponses.map((d) =>
									d.avgResponseSS.toFixed(2)
								),
							},
							{
								name: '平均响应时长(秒)',
								type: 'line',
								stack: '2',
								data: data.data.response.map((d) =>
									d.avgResponseSS.toFixed(2)
								),
							},
							{
								name: '平均会话时长(分)',
								type: 'line',
								stack: '3',
								data: data.data.avgSessionTime.map(
									(d) => d.avgResponseSS
								),
							},
						],
					}
					myChart7.setOption(option2)
				})
		},
		getGetConsultationGroups() {
			// label: {
			// 						normal: {
			// 							show: false,
			// 							position: 'center'
			// 						},
			// 						emphasis: {
			// 							show: true,
			// 							textStyle: {
			// 								fontSize: '12',
			// 								fontWeight: 'bold'
			// 							}
			// 						}
			// 					},
			let vm = this
			let myChart6 = this.$echarts.init(document.getElementById('main-6'))
			vm.consultationLoading = true
			this.axios
				.post(
					'HistoryReportForm/GetConsultationGroups',
					this.getWhere()
				)
				.then(function ({ data }) {
					if (data.result) {
						let nameArr = data.data.map((d) => d.typeName)
						let dataArr = []
						data.data.forEach((element) => {
							let obj = new Object()
							obj.value = element.count
							obj.name = element.typeName
							obj.typeId = element.typeId
							dataArr.push(obj)
						})
						let option6 = {
							title: {
								left: 'center',
								top: 10 + 'px',
								text: '',
								textStyle: {
									color: '#000',
									fontSize: 16,
									fontweight: 500,
								},
							},
							legend: {
								show: true,
								icon: 'circle',
								orient: 'vertical',
								align: 'left',
								itemWidth: 12, // 设置宽度
								itemHeight: 12, // 设置高度
								x: 'right',
								y: 40 + 'px',
								data: nameArr,
								fontSize: 12,
							},
							label: {
								show: true,
								formatter: '{b} : {c} ({d}%)',
							},
							tooltip: {
								trigger: 'item',
								formatter: '{b} : {c} ({d}%)',
							},
							series: [
								{
									type: 'pie',
									center: ['35%', '50%'],
									radius: ['30%', '50%'],
									data: dataArr,
									color: [
										'rgb(230,63,67)',
										'rgb(255,143,88)',
										'rgb(255,195,55)',
										'rgb(196,153,111)',
										'#bcd3bb',
										'#e88f70',
										'#edc1a5',
										'#9dc5c8',
										'#e1e8c8',
										'#7b7c68',
										'#e5b5b5',
										'#f0b489',
									],
								},
							],
							itemStyle: {
								emphasis: {
									shadowBlur: 10,
									shadowOffsetX: 0,
									shadowColor: 'rgba(0, 0, 0, 0.5)',
								},
								// 这里做改变
								normal: {
									label: {
										show: true,
										formatter: '{b} : {c} ({d}%)',
									},
									labelLine: {
										show: true,
									},
								},
							},
						}
						myChart6.setOption(option6)
						myChart6.on('click', (e) => {
							let { data } = e
							let typeId = data.typeId
							let startTime = vm.pickerTime[0]
							let endTime = vm.pickerTime[1]
							let obj = {
								typeId: typeId,
								startTime: startTime,
								endTime: endTime,
								type: 'conType',
								index: '3',
							}
							vm.$emit('children', obj)
						})
						vm.consultationLoading = false
					}
				})
		},
		convertMin(ss) {
			//转换
			let dateTime = new DateTime()
			return dateTime.convertSSAndMin(ss)
		},
		enter(index) {
			if (index == 1) {
				this.classes = 'flex-dialog on'
			} else if (index == 2) {
				this.classes2 = 'flex-dialog on'
			} else if (index == 3) {
				this.classes3 = 'flex-dialog on'
			} else if (index == 4) {
				this.classes4 = 'flex-dialog on'
			} else if (index == 5) {
				this.classes5 = 'flex-dialog on'
			} else if (index == 6) {
				this.classes6 = 'flex-dialog on'
			} else if (index == 7) {
				this.classes7 = 'flex-dialog on'
			} else if (index == 8) {
				this.classes8 = 'flex-dialog on'
			}
		},
		leave(index) {
			if (index == 1) {
				this.classes = 'flex-dialog'
			} else if (index == 2) {
				this.classes2 = 'flex-dialog'
			} else if (index == 3) {
				this.classes3 = 'flex-dialog'
			} else if (index == 4) {
				this.classes4 = 'flex-dialog'
			} else if (index == 5) {
				this.classes5 = 'flex-dialog'
			} else if (index == 6) {
				this.classes6 = 'flex-dialog'
			} else if (index == 7) {
				this.classes7 = 'flex-dialog'
			} else if (index == 8) {
				this.classes8 = 'flex-dialog'
			}
		},
		exportTable() {
			let vm = this
			vm.exportLoading = true
			this.axios
				.post('HistoryReportForm/ExportHistory', this.getWhere(), {
					responseType: 'blob',
				})
				.then(function (res) {
					
					let filename = `历史数据${vm.pickerTime[0]}_${vm.pickerTime[1]}.xls`
					let blob = res.data
					let reader = new FileReader()
					reader.readAsDataURL(blob)
					reader.onload = (e) => {
						//创建a标签，插入到文档中并click，最后移除
						let a = document.createElement('a')
						a.download = filename
						a.href = e.target.result
						document.body.appendChild(a)
						a.click()
						document.body.removeChild(a)
						vm.exportLoading = false
						vm.$message({ type: 'success', message: '导出成功' })
					}
				})
		},
		getOnlineUserCount() {
			let vm = this
			let myChart = this.$echarts.init(
				document.getElementById('onLineCount')
			)
			vm.axios
				.post('HistoryReportForm/GetOnlineUserCount', vm.getWhere())
				.then(function ({ data }) {
					if (!data.result) {
						return
					}
					let option = {
						tooltip: {
							trigger: 'axis',
							formatter: function (params) {
								return `时间:${params[0].name}:${params[0].value}`
							},
						},
						xAxis: {
							type: 'category',
							data: data.data.map((d) => d.time),
						},
						yAxis: {
							type: 'value',
						},
						series: [
							{
								data: data.data.map((d) => parseFloat(d.val)),
								type: 'bar',
								itemStyle: {
									//通常情况下：
									normal: {
										//每个柱子的颜色即为colorList数组里的每一项，如果柱子数目多于colorList的长度，则柱子颜色循环使用该数组中的颜色
										// color: function(params) {
										// 	var colorList = [
										// 		'#C1232B',
										// 		'#B5C334',
										// 		'#FCCE10',
										// 		'#E87C25',
										// 		'#27727B',
										// 		'#FE8463',
										// 		'#9BCA63',
										// 		'#FAD860',
										// 		'#F3A43B',
										// 		'#60C0DD',
										// 		'#D7504B',
										// 		'#C6E579',
										// 		'#F4E001',
										// 		'#F0805A',
										// 		'#26C0C0'
										// 	]
										// 	return colorList[params.dataIndex]
										// }
										color: '#409eff', //设置所有柱状图颜色
									},
								},
							},
						],
					}
					myChart.setOption(option)
				})
		},
	},
}
</script>

<style scoped>
.system .flex {
	padding: 30px 0 10px 0;
}
.system .title {
	font-size: 22px;
	float: left;
	position: relative;
}
.flex-dialog {
	max-width: 1000px;
	display: none;
	position: absolute;
	padding: 20px;
	background-color: #fff;
	top: 25px;
	left: 30px;
	box-shadow: 0 0 4px #ddd;
	z-index: 1000;
}
.flex-dialog.on {
	display: block;
}
.flex-dialog p {
	white-space: nowrap;
	line-height: 28px;
	font-size: 14px;
	color: #333;
}
.flex-dialog p span {
	display: inline-block;
	width: 165px;
}
.system .flex-box {
	width: 100%;
	display: flex;
	display: -webkit-flex;
	align-items: flex-start;
	justify-content: center;
	min-height: 200px;
}
.system .flex-box .m-ValueBox {
	flex: 1;
	border: 1px solid #ddd;
	text-align: center;
}
.system .m-ValueBox-top {
	padding-top: 18px;
	padding-bottom: 15px;
	background-color: #fff;
}
.system .m-ValueBox-top > div:nth-child(2) {
	font-size: 30px;
	min-height: 45px;
	color: #337eff;
	margin-top: 10px;
	white-space: nowrap;
	text-align: center;
}
.system .m-ValueBox-bottom {
	display: -webkit-box;
	display: flex;
	-webkit-box-orient: vertical;
	-webkit-box-direction: normal;
	flex-direction: column;
	justify-content: space-around;
	height: 90px;
	border-top: 1px solid #ddd;
}
.m-echart {
	margin-top: 30px;
}
.m-echart-titleTxt {
	font-size: 22px;
	position: relative;
}

.m-echart-title {
	margin-bottom: 30px;
}
.flex-box > div {
	flex: 1;
	margin-right: 30px;
}
.m-bar {
	display: flex;
	display: -webkit-flex;
	align-items: center;
	justify-content: flex-start;
	line-height: 40px;
}
.m-bar .m-bar-title {
	width: 15%;
}
.m-bar .percent {
	width: 5%;
	text-align: right;
}
.m-bar .progress {
	height: 15px;
	width: 80%;
}
.m-bar .progress > div {
	height: 15px;
	width: 0;
	transition: width 2s;
	-webkit-transition: width 2s;
}
.m-bar .progress .p1 {
	background-color: #3a8ee6;
}
.m-bar .progress .p2 {
	background-color: #e6a23c;
}
.m-bar .progress .p3 {
	background-color: #df5000;
}
.m-bar .progress .p4 {
	background-color: #5abc5c;
}
.m-bar .progress .p5 {
	background-color: #795da3;
}
.canvas {
	line-height: 300px;
	height: 300px;
	text-align: center;
	border: 1px solid #ddd;
}

/* .el-button {
	background-color: #fafafa;
} */
</style>




// WEBPACK FOOTER //
// src/components/manage/system/overview.vue